import React, { useState, useEffect, useRef } from "react";
import { WebService } from "../../Services/WebService";
import { useDispatch, useSelector } from "react-redux";
import StaticListComponent from "../../Services/StaticListComponent";
import "../Static/Static.css";
import ActionButton from "../../Services/ActionButton";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import SnackbarComponent from "../../Services/SnackbarComponent";
import AddEditBankDetails from "./AddEditBankDetails";
import "./Static.css";
import { ActionPermission, PageInfo } from "../PageInfo";
import "./Master.css";
import "../Static/Static.css";
import { NoRecordTemplate } from "../../Services/TableComponent";
import Button from "react-bootstrap/esm/Button";
import { StandardConst } from "../../Services/StandardConst";
import { where } from "underscore";

const BankDetails = () => {
  PageInfo({ pageTitle: "Bank Details" });
  const loggedUser=useSelector(s=>s.auth.LoggedUser??0);
  
  const [permission, SetPermission] = useState({});
  const permissionList = useSelector((s) => s.auth.PermissionList??[]);
  useEffect(() => {
    SetPermission({
      ManageSearchAllUser: ActionPermission("Bank Details - Search All User"),
    });
    fetchBankDetails();
  }, [permissionList, loggedUser]);

  
  const ref = useRef();
  const refSnackbar = useRef();
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);

  const fetchBankDetails = async () => {
    const p1 = WebService({
      endPoint: "FinanceTemplate/Fetch",
      dispatch,
    })
    .then(r=>{
      const manageSearchAllUser = ActionPermission("Bank Details - Search All User")
      if(manageSearchAllUser===false){
        return where(r,{EmployeeId: loggedUser});
      }
      return r;
    })
    .then(r=>{
      setRecords(r);
    });
    await Promise.all([p1]);
  };

  const onDelete = async (FinanceId) => {
    await WebService({
      endPoint: `FinanceTemplate/Remove/${FinanceId}`,
      method: "DELETE",
      dispatch,
    });
    refSnackbar.current.setOpenSnackBar();
    fetchBankDetails();
  };

  const renderAfterCalled = useRef(false);
  const addEditModalRef = useRef();
  // useEffect(() => {
  //   if (!renderAfterCalled.current) {
  //     fetchBankDetails();
  //   }
  //   renderAfterCalled.current = true;
  // }, []);
  const columns = [
    {
      Text: "Name in Account",
      Value: "NameInAccount",
    },
    {
      Text: "Bank Name",
      Value: "BankName",
    },
    {
      Text: "Bank Account Number",
      Value: "BankAccountNo",
    },
    // {
    //   Text: "IFSC Code",
    //   Value: "IFSCCode",
    // },
    // {
    //   Text: "PF Number",
    //   Value: "PFAccountNo",
    // },
    // {
    //   Text: "PF UAN Number",
    //   Value: "PFUANNo",
    // },
    {
      Searchable: false,
      Text: "Action",
      key: "FinanceId",
      cssClass: "text-center td-width-100",
      //isVisiable: permission.ManageEdit || permission.ManageDelete,
      Template: (
        <>
          <ActionButton
            onClick={(e) =>
              fnEdit(e.currentTarget.closest("[data-key]")?.getAttribute("data-key"))
            }
            //disabled={!permission.ManageEdit}
            IconName="Edit"
            id="btnBankDetailsEdit"
          />

          <ActionButton
            onClick={(e) =>
              ref.current.confirmAlert(
                "Delete", //Confirm button text
                "Are You Sure", // Text if Alert
                "Do you want to delete " + MasterPageName, // Message of Alert
                e.currentTarget.closest("[data-key]")?.getAttribute("data-key") // Endpoint to hit for delete
              )
            }
            IconName="Delete"
            id="btnBankDetailsDelete"
          />
        </>
      ),
    },
  ];
  const [bData, setBData] = React.useState([
    {
      title: "Employee",
      hrefLink: "#",
    },
    {
      title: "Bank Details",
      hrefLink: "#",
    },
  ]);
  const MasterPageName = "Bank Details";
  const confirmMessage = MasterPageName + " Deleted successfully";

  const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);
  return (
    <>
      <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
      <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />
      <StaticListComponent
        columns={columns}
        records={records}
        bData={bData}
        MasterPageName={MasterPageName}
        noRecordCss="p-0"
        noRecordFound={
          <NoRecordTemplate
            headerValue={StandardConst.BankDetailsheaderValueNoResults}
            subHeaderValue={StandardConst.BankDetailsSubHeaderRole}
            imageUrl={StandardConst.imageNoRecordsFound}
            actionButton={
              <>
                <Button id="NoRecordFoundAddBankDetails" variant="outline-primary" onClick={() => fnEdit(0)}>
                  Add {MasterPageName}
                </Button>
              </>
            }
          />
        }
        onAddEvent={() => fnEdit()}
        //IsAddButtonVisible={permission?.ManageAdd}
        isSearchRequired={true}
        allowSerialNo={true}
      ></StaticListComponent>
      <AddEditBankDetails
        callBackEvent={() => fetchBankDetails()}
        ref={addEditModalRef}
      ></AddEditBankDetails>
    </>
  );
};
export default BankDetails;
